<template>
  <div class="dropdown-block">
    <div class="heading">
      {{ label }}
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" @click="changeVal('decrement')">
          <span class="subtract">&#8722;</span>
        </span>
      </div>
      <input class="amount form-control" type="number" v-model="ownValue" @change="input" min="0">
      <div class="input-group-append">
        <span class="input-group-text" @click="changeVal('increment')">
          <span class="add">&#43;</span>
        </span>
      </div>
    </div>
    <!--    <div class="input-group">-->
    <!--      <input type="text" class="form-control" v-model="ownValue" @input="input">-->
    <!--      <div class="input-group-append">-->
    <!--        <span class="input-group-text">{{ unit }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>

export default {
  name: 'MenuItemAmount',
  props: {
    label: {
      default: 'Placeholder label'
    },
    val: {
      default: 0
    },
  },
  data() {
    return {
      ownValue: this.val,
    }
  },
  methods: {
    input(e) {
      let value = e.target.value;
      if (isNaN(e.target.value)) {
        value = 0;
      }
      this.ownValue = value;
      this.$emit('input', value);
      this.$emit('change', value);

    },
    changeVal(type) {
      if(type === 'decrement' && this.ownValue !== 0) {
        this.ownValue--;
      } else if(type === 'increment') {
        this.ownValue++;
      }
      this.$emit('change', this.ownValue);

    }
  },
  watch: {
    val: {
      deep: false,
      handler(val) {
        this.ownValue = val;
        this.$emit('change', val)
      }
    }
  }
}
</script>

<style lang="scss">
.input-group-prepend {
  .input-group-text {
    border-radius: 25px 0 0 25px !important;
  }
}

.add,
.subtract {
  font-size: 30px;
  cursor: pointer;
  user-select: none;

  &:hover {
    transform: scale(1.4);
  }
}

.amount {
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

